import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { getPermissionsMatrix, savePermissionsMatrix } from "../../../../services/platform_admin_service";

const usePlatformPermissions = () => {
    const [rolesPermissions, setRolesPermissions] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [dirty, setDirty] = useState(false);
    const [error, setError] = useState(null);
    const [alertText, setAlertText] = useState(null);

    const fetchMatrix = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const result = await getPermissionsMatrix();
            setRolesPermissions(result.roles || {});
            setDirty(false);
        } catch (err) {
            console.error("[usePlatformPermissions]", err);
            setError(err.message || "Erro ao carregar a matriz de permissões.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMatrix();
    }, [fetchMatrix]);

    const togglePermission = (roleKey, permissionKey) => {
        if (roleKey === "owner") {
            setAlertText("O cargo de Proprietário (Owner) possui acesso completo inalterável por motivos de segurança.");
            setTimeout(() => setAlertText(null), 3000);
            return;
        }
        setRolesPermissions(prev => ({
            ...prev,
            [roleKey]: {
                ...prev[roleKey],
                [permissionKey]: !prev[roleKey]?.[permissionKey],
            },
        }));
        setDirty(true);
    };

    const saveMatrix = async () => {
        try {
            setSaving(true);
            const result = await savePermissionsMatrix(rolesPermissions);
            setDirty(false);
            toast.success(
                result.usersUpdated > 0
                    ? `Permissões salvas. ${result.usersUpdated} usuário(s) sincronizado(s).`
                    : "Permissões salvas com sucesso."
            );
        } catch (err) {
            console.error("[usePlatformPermissions] save", err);
            toast.error(err.message || "Erro ao salvar a matriz de permissões.");
        } finally {
            setSaving(false);
        }
    };

    const dismissAlert = () => setAlertText(null);

    return {
        rolesPermissions,
        loading,
        saving,
        dirty,
        error,
        alertText,
        togglePermission,
        saveMatrix,
        dismissAlert,
        refetch: fetchMatrix,
    };
};

export default usePlatformPermissions;
